import React from 'react';
import { PropTypes } from 'prop-types';
import { Skeleton, Table } from '@mantine/core';
import dayjs from 'dayjs';
import NumberFormat from 'react-number-format';
import {
  CURRENCY_TYPE_LIST,
  OFFLINE_PAYMENT_TYPES,
  PAYMENT_TYPE_ENUM
} from '../../../config/constants';
import { formatUtcDate } from '../../../helpers/format';
import AppText from '../../common/AppText';

const CARD_PAYMENT_TYPES = [
  PAYMENT_TYPE_ENUM.STRIPE,
  PAYMENT_TYPE_ENUM.AFTERPAY,
  PAYMENT_TYPE_ENUM.SPORTSPAY,
  PAYMENT_TYPE_ENUM.SPORTSPAY_INSTALLMENTS
];

const CustomerTransactionListItem = ({ regFormSubmissionPayment }) => {
  const paymentTypeValue =
    regFormSubmissionPayment?.fkRegFormSubmissionPaymentType?.toString() ?? '';
  const paymentType = OFFLINE_PAYMENT_TYPES.find(
    (t) => t.value === paymentTypeValue
  );
  const isRefund = paymentTypeValue === PAYMENT_TYPE_ENUM.REFUND;
  const currency = CURRENCY_TYPE_LIST.find(
    (c) =>
      c.value.toString() ===
      regFormSubmissionPayment?.fkCurrencyType?.toString()
  )?.abbr;

  return regFormSubmissionPayment ? (
    <Table.Tr>
      <Table.Td>
        <AppText
          color={isRefund ? 'red' : 'green'}
          style={{ whiteSpace: 'nowrap', wordBreak: 'normal' }}
        >
          {isRefund ? 'Refund' : 'Paid'}
        </AppText>
      </Table.Td>
      <Table.Td>
        <AppText style={{ whiteSpace: 'nowrap', wordBreak: 'normal' }}>
          {dayjs(formatUtcDate(regFormSubmissionPayment.createdAt)).format(
            'MM/DD/YYYY'
          )}
        </AppText>
      </Table.Td>
      <Table.Td>
        <AppText style={{ whiteSpace: 'nowrap', wordBreak: 'normal' }}>
          {paymentType?.label ?? 'Payment'}
        </AppText>
      </Table.Td>
      <Table.Td>
        <AppText style={{ whiteSpace: 'nowrap', wordBreak: 'normal' }}>
          {CARD_PAYMENT_TYPES.includes(paymentTypeValue)
            ? 'Card'
            : paymentTypeValue === PAYMENT_TYPE_ENUM.JUMPSTART
            ? 'Assistance'
            : 'Offline'}
        </AppText>
      </Table.Td>
      <Table.Td>
        <AppText
          color={
            isRefund || regFormSubmissionPayment.amount < 0 ? 'red' : 'green'
          }
          style={{
            textAlign: 'end',
            whiteSpace: 'nowrap',
            wordBreak: 'normal'
          }}
        >
          <NumberFormat
            decimalScale={2}
            displayType="text"
            fixedDecimalScale
            prefix="$"
            thousandSeparator
            value={regFormSubmissionPayment.amount}
          />{' '}
          {currency}
        </AppText>
      </Table.Td>
    </Table.Tr>
  ) : (
    <Table.Tr>
      <Table.Td>
        <Skeleton height={10} width={60} />
      </Table.Td>
      <Table.Td>
        <Skeleton height={10} width={100} />
      </Table.Td>
      <Table.Td>
        <Skeleton height={10} width={80} />
      </Table.Td>
      <Table.Td>
        <Skeleton height={10} width={80} />
      </Table.Td>
      <Table.Td>
        <Skeleton height={10} style={{ alignSelf: 'end' }} width={80} />
      </Table.Td>
    </Table.Tr>
  );
};

CustomerTransactionListItem.propTypes = {
  regFormSubmissionPayment: PropTypes.object
};

export default CustomerTransactionListItem;
